import { withApiContext, withLabelsContext, withUserContext } from "context";
import React, { PureComponent } from "react";
import { Col, Collapse, Modal, Row } from "react-bootstrap";
import { Loader } from 'components';
import "./ChapterProgress.css";
import ChapterRibbon from "./ChapterRibbon";
import ChapterScatterChart from "./ChapterScatterChart";
import ChapterStudentTable from "./ChapterStudentTable/index";
import styled from "styled-components";
import { rgba } from "polished"
import ChapterList from "pages/Course/Components/ChapterList";
import { Link, withRouter } from "react-router-dom";
import MediaQuery from "react-responsive";
import * as config from "config";
import * as util from "services/util";

const Badge = styled.div`
  display: inline-block;
  font-size: 10px;
  font-weight: 600;
  color: #ffffff;
  min-width: 80px;
  text-align: center;
  padding: 6px 10px;
  line-height: 10px;
  border-radius: 22px;
`;

const BadgeCompleted = styled(Badge)`
  background-color: ${({ theme }) => rgba(theme.color2, 1)};
`;

const BadgeProgress = styled(Badge)`
  background-color: ${({ theme }) => rgba(theme.color3, 0.6)};
`;

const BadgeYetToStart = styled(Badge)`
  background-color: ${({ theme }) => rgba(theme.color4, 0.4)};
`;




class ChapterProgress extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { typeId: 1, totalRows: 0 };
    this.state = { totalRows: 0 };
    this.state = {
      tableData: [],
      scatterData: [],
      chartData: [],
      chapterIds: [],
      loading: true,
      type: "",

      selectedChapterId: "",
      statisticsModal: false,
      leaderboardModal: false,
      chapterProgress: true,
      ...this.initSelectState,
      isSubjectProgress: true,
    };
  }

  getClassName = (value) =>
    value <= 40
      ? "progress-bar-danger"
      : value > 40 && value <= 60
        ? "progress-bar-warning"
        : value > 60 && value <= 80
          ? "progress-bar-info"
          : value > 80
            ? "progress-bar-success"
            : "progress-bar-danger";

  static propTypes = {};

  static defaultProps = {};

  handleTableData = (content) => {
    const id = content.chapter_id;
    const coursePublishId = this.props.entity?.course_publish_id || this.props.entity?.coursePublishId;
    const studentData = content.student_details
      ? content.student_details.map((detail) => {
        return {
          ...detail,
          course_publish_id: coursePublishId, // Add course_publish_id for API call
          statusBadge:
            detail.status === 1 ? (
              <BadgeYetToStart>Yet to Start</BadgeYetToStart>
            ) : detail.status === 2 ? (
              <BadgeProgress>In Progress</BadgeProgress>
            ) : detail.status === 3 ? (
              <BadgeCompleted>Attended</BadgeCompleted>
            ) : null,
        };
      })
      : [];
    return {
      id: id,
      headers: [
        {
          name: "Reg No",
          selector: row => row.registration_no,
          omit: true
        },
        {
          name: this.props.ctx_labels.singular.member,
          selector: row => row.student_name,
          sortable: true
          // headerClassName: "rt-tr-align-left",
        },
        {
          name: "Status",
          selector: row => row.statusBadge,
          width: "20%"
          // headerClassName: "rt-tr-align-left",
        },
        {
          name: "Progress %",
          selector: row => row.progress_percent,
          // headerClassName: "rt-tr-align-left",
          Cell: (props) => {
            const progress = { width: `${props.value}%` };
            const progressClass =
              props.value <= 40
                ? "progress-bar-danger"
                : props.value > 40 && props.value <= 60
                  ? "progress-bar-warning"
                  : props.value > 60 && props.value <= 80
                    ? "progress-bar-info"
                    : props.value > 80
                      ? "progress-bar-success"
                      : "progress-bar-danger";
            return (
              <Row style={{ display: "flex", flexDirection: "row" }}>
                <Col md={2}>
                  <span className={"badge " + progressClass}>
                    {props.value}
                  </span>
                </Col>
                <Col md={10}>
                  <div
                    className="progress progress-height"
                    style={{ height: "7px" }}
                  >
                    <div
                      className={"progress-bar " + progressClass}
                      style={progress}
                    ></div>
                  </div>
                </Col>
              </Row>
            );
          },
        },
        {
          name: "Minutes Viewed",
          selector: row => row.minutes_viewed,
          // headerClassName: "rt-tr-align-left",
        },
        {
          name: "Pages Viewed",
          selector: row => row.pages_viewed,
          // headerClassName: "rt-tr-align-left",
        },
        {
          name: "PLE Score",
          selector: row => row.ple_score,
          headerClassName: "rt-tr-align-left",
        },
        {
          name: "Detailed View",
          selector: row => row.detailed_view,
          sortable: false,
          width: "120px",
          cell: (row) => {
            // Exclude statusBadge (React element) from router state
            const { statusBadge, ...serializableData } = row;
            return (
              <Link
                to={{
                  pathname: config.ROUTES.subjectProgressDetail,
                  state: { data: serializableData },
                }}
              >
                View Details
              </Link>
            );
          },
        },
      ],
      contents: [...studentData],
    };
  };
  componentDidMount() {
    // this.search().then((rsp) => this.handleResponse(rsp));
    this.getCourseProgressStudent()
    this.renderStudentTable()
  }
  toPdfLength = (n) => `${n} page${n === 1 ? "" : "s"}`;
  handleModuleTableData = (content) => {
    const coursePublishId = this.props.entity?.course_publish_id || this.props.entity?.coursePublishId;
    const studentModuleData = content.student_progress ? content.student_progress.map((detail) => {
      return {
        ...detail,
        course_publish_id: coursePublishId, // Add course_publish_id for API call
        statusBadge:
          detail.modules[0].module_status === "Yet To Start" ? (
            <BadgeYetToStart>Yet to Start</BadgeYetToStart>
          ) : detail.modules[0].module_status === "In progress" ? (
            <BadgeProgress>In Progress</BadgeProgress>
          ) : detail.modules[0].module_status === "Completed" ? (
            <BadgeCompleted>Attended</BadgeCompleted>
          ) : null,
        progressPerc: detail.modules[0].progress_perc === null ? "0" : detail.modules[0].progress_perc,
        pleCredit: detail.modules[0].ple_credit === null ? "0" : detail.modules[0].ple_credit,
        correctAns: detail.modules[0].correct_answer === null ? "0" : detail.modules[0].correct_answer,
        minPageView: detail.modules[0].minutes_viewed === null ? "0" : detail.modules[0].minutes_viewed,
        //contentLength:detail.modules[0].content_length === null ? "0" : detail.modules[0].content_length
        // contentLength:detail.modules[0].module_type === "PDF" ? this.toPdfLength(detail.modules[0].content_length) : detail.modules[0].content_length
        // :detail.modules[0].module_type === "Video" ? util.toHHMMSS(detail.modules[0].content_length) : detail.modules[0].content_length
        //:detail.modules[0].module_type === "Audio" ? util.toHHMMSS(detail.modules[0].content_length) : detail.modules[0].content_length,
        contentLength:
          detail.modules[0] && detail.modules[0].module_type === "PDF"
            ? this.toPdfLength(detail.modules[0].content_length)
            : detail.modules[0] && detail.modules[0].module_type === "TEXTEDITOR"
              ? this.toPdfLength(detail.modules[0].content_length)
              : detail.modules[0] && detail.modules[0].module_type === "HTML"
                ? this.toPdfLength(detail.modules[0].content_length)
                : detail.modules[0] && detail.modules[0].module_type === "PPT"
                  ? this.toPdfLength(detail.modules[0].content_length)
                  : detail.modules[0] && detail.modules[0].module_type === "VIDEO"
                    ? util.toHHMMSS(detail.modules[0].content_length)
                    : detail.modules[0] && detail.modules[0].module_type === "AUDIO"
                      ? util.toHHMMSS(detail.modules[0].content_length)
                      : detail.modules[0] && detail.modules[0].content_length || 0,

      };
      // })
    })
      : [];
    return {
      headers: [
        {
          name: this.props.ctx_labels.singular.member,
          selector: row => row.student_name,
          sortable: true,
          sortFunction: (a, b) => a.student_name.localeCompare(b.student_name),
          // headerClassName: "rt-tr-align-left",
        },
        {
          name: "Status",
          selector: row => row.statusBadge,
          // headerClassName: "rt-tr-align-left",
        },
        {
          name: "Progress %",
          selector: row => row.progressPerc,
          // headerClassName: "r
        },
        {
          name: "Minutes/Pages Viewed",
          selector: row => row.minPageView,
        },
        {
          name: "Correct Answers ",
          selector: row => row.correctAns,
        },
        {
          name: "PLE Credit",
          selector: row => row.pleCredit,
        },
        {
          name: "Total Length",
          selector: row => row.contentLength,
        },
        {
          name: "Detailed View",
          selector: row => row.detailed_view,
          sortable: false,
          width: "120px",
          cell: (row) => {
            // Exclude statusBadge (React element) from router state
            const { statusBadge, ...serializableData } = row;
            return (
              <Link
                to={{
                  pathname: config.ROUTES.subjectProgressDetail,
                  state: { data: serializableData },
                }}
              >
                View Details
              </Link>
            );
          },
        },

      ],
      contents: [...studentModuleData],
    };
  };

  handleTableTestData = (content) => {
    const testId = content.id;
    const attendedStudents = content.student_progress?.flatMap((dtl) => {
      return dtl.assessment.filter((d) => d.status === 3).map((filteredItem) => {
        return {
          ...filteredItem,
          name: dtl.student_name,
          traineeId: dtl.student_id,
        };
      });
    })


    const studentTestData = content.student_progress ? content.student_progress.map((detail) => {
      return {
        ...detail,
        statusBadge:
          detail.assessment[0].status === 1 ? (
            <BadgeYetToStart>Yet to Start</BadgeYetToStart>
          ) : detail.assessment[0].status === 2 ? (
            <BadgeProgress>In Progress</BadgeProgress>
          ) : detail.assessment[0].status === 3 ? (
            <BadgeCompleted>Attended</BadgeCompleted>
          ) : null,
        totMarks: detail.assessment[0].tot_obt_marks === null ? "0" : detail.assessment[0].tot_obt_marks,
        scorePercentage: detail.assessment[0].score_percentage === null ? "0" : detail.assessment[0].score_percentage,
        evaluatedBy: detail.assessment[0].evaluated === 0 && detail.assessment[0].evaluated_by === null ? "Evaluation Pending" : detail.assessment[0].evaluated === 1 && detail.assessment[0].evaluated_by === null ? "System Evaluation" : detail.assessment[0].evaluated_by,
        testAssessmentId: detail.assessment[0].test_assessment_id === null ? "0" : detail.assessment[0].test_assessment_id,
        totPoints: detail.assessment[0].test_points === null ? "0" : detail.assessment[0].test_points,
      };
      // })
    })
      : [];
    // const testAssessmentId = studentTestData.map((assessmentId) => {

    // })   //   return assessmentId.testAssessmentId;
    return {
      headers: [
        {
          name: this.props.ctx_labels.singular.member,
          selector: row => row.student_name,
          sortable: true,
          sortFunction: (a, b) => a.student_name.localeCompare(b.student_name),
          // headerClassName: "rt-tr-align-left",
        },
        {
          name: "Status",
          selector: row => row.statusBadge,
          // headerClassName: "rt-tr-align-left",
        },
        {
          name: "Score Percentage",
          selector: row => row.scorePercentage,
          // headerClassName: "r
        },
        // {
        //   name: "Minutes Viewed",
        //   selector: "minutes_viewed",
        // },
        {
          name: "Obtained Marks",
          selector: row => row.totMarks,
        },
        {
          name: "Evaluated By",
          selector: row => row.evaluatedBy,
        },
        {
          name: "Total Score",
          selector: row => row.totPoints,
        },
        {
          name: "Link",
          selector: row => row.link,
          sortable: false,
          width: "100px",
          cell: (row, index) => {
            return (
              row.statusBadge.props.children === "Attended" ?
                (<Link
                  //onClick={() => this.props.addRedirection()}
                  to={{
                    // pathname: config.ROUTES.evaluateForm, 
                    formDatas: row,
                    pathname: config.ROUTES.trainerEvaluate,
                    // formData: row,
                    entityDatas: this.props.entity,
                    // entityData: this.props.entity,
                    testAssessmentId: `${row.testAssessmentId}`,
                    studentid: `${row.student_id}`,
                    testId: testId,
                    isSubjectProgress: this.state.isSubjectProgress,
                    className: this.props.class,
                    addRedirection: this.props.addRedirection,
                    dueDate: this.props.entity.publishedTo,
                    selectedItem: attendedStudents,
                    chapterProgress: this.state.chapterProgress,
                    ...(this.props.fromTeacherAnalytics && { fromTeacherAnalytics: this.props.fromTeacherAnalytics }),
                    ...(this.props.fromClassAnalytics && { fromClassAnalytics: this.props.fromClassAnalytics }),
                    ...(this.props.reroutingData && { reroutingData: this.props.reroutingData }),
                    ...(this.props.activeStudents && { activeStudents: this.props.activeStudents }),
                    ...(this.props.totalStudents && { totalStudents: this.props.totalStudents }),
                  }}>view</Link>) :
                row.statusBadge.props.children !== "Attended" ?
                  <Link
                    to="/"
                    className="disabledCursor"
                    onClick={(event) => event.preventDefault()} >
                    View
                  </Link>
                  : ""
            )
          }
        }
      ],
      contents: [...studentTestData],
    };
  };

  handleTableSurveyData = (content) => {
    console.log(content)
    const testId = content.id;
    const attendedStudents = content.student_progress?.flatMap((dtl) => {
      return dtl.assessment.filter((d) => d.status === 2).map((filteredItem) => {
        return {
          ...filteredItem,
          name: dtl.student_name,
          traineeId: dtl.student_id,
        };
      });
    })


    const studentTestData = content.student_progress ? content.student_progress.map((detail) => {
      return {
        ...detail,
        statusBadge:
          detail.assessment[0].status === 1 ? (
            <BadgeYetToStart>Yet to Start</BadgeYetToStart>
          ) : detail.assessment[0].status === 2 ? (
            <BadgeProgress>Attended</BadgeProgress>
          ) : detail.assessment[0].status === 3 ? (
            <BadgeCompleted>Attended</BadgeCompleted>
          ) : null,
        totMarks: detail.assessment[0].tot_obt_marks === null ? "0" : detail.assessment[0].tot_obt_marks,
        // scorePercentage: detail.assessment[0].score_percentage === null ? "0" : detail.assessment[0].score_percentage,
        // evaluatedBy: detail.assessment[0].evaluated === 0 && detail.assessment[0].evaluated_by === null ? "Evaluation Pending" : detail.assessment[0].evaluated === 1 && detail.assessment[0].evaluated_by === null ? "System Evaluation" : detail.assessment[0].evaluated_by,
        // testAssessmentId: detail.assessment[0].test_assessment_id === null ? "0" : detail.assessment[0].test_assessment_id,
        // totPoints: detail.assessment[0].test_points === null ? "0" : detail.assessment[0].test_points,
      };
      // })
    })
      : [];
    // const testAssessmentId = studentTestData.map((assessmentId) => {
    //   return assessmentId.testAssessmentId;
    // })
    return {
      headers: [
        {
          name: this.props.ctx_labels.singular.member,
          selector: row => row.student_name,
          sortable: true,
          sortFunction: (a, b) => a.student_name.localeCompare(b.student_name),
          // headerClassName: "rt-tr-align-left",
        },
        {
          name: "Status",
          selector: row => row.statusBadge,
          // headerClassName: "rt-tr-align-left",
        },
        //  {
        //   name: "ContentLength",
        //   selector: row => row.length,
        //   // headerClassName: "rt-tr-align-left",
        // },
        // {
        //   name: "Score Percentage",
        //   selector: row => row.scorePercentage,
        //   // headerClassName: "r
        // },
        // // {
        // //   name: "Minutes Viewed",
        // //   selector: "minutes_viewed",
        // // },
        // {
        //   name: "Obtained Marks",
        //   selector: row => row.totMarks,
        // },
        // {
        //   name: "Evaluated By",
        //   selector: row => row.evaluatedBy,
        // },
        // {
        //   name: "Total Score",
        //   selector: row => row.totPoints,
        // },
        // {
        //   name: "Link",
        //   selector: row => row.link,
        //   sortable: false,
        //   width: "100px",
        //   cell: (row, index) => {
        //     return (
        //       row.statusBadge.props.children === "Attended" ?
        //         (<Link
        //           //onClick={() => this.props.addRedirection()}
        //           to={{
        //             // pathname: config.ROUTES.evaluateForm, 
        //             formDatas: row,
        //             pathname: config.ROUTES.trainerEvaluate,
        //             // formData: row,
        //             entityDatas: this.props.entity,
        //             // entityData: this.props.entity,
        //             testAssessmentId: `${row.testAssessmentId}`,
        //             studentid:`${row.student_id}`,
        //             testId:testId,
        //             isSubjectProgress:this.state.isSubjectProgress,
        //             className: this.props.class,
        //             addRedirection: this.props.addRedirection,
        //             dueDate: this.props.entity.publishedTo,
        //             selectedItem: attendedStudents,
        //             chapterProgress: this.state.chapterProgress,
        //             ...(this.props.fromTeacherAnalytics && { fromTeacherAnalytics: this.props.fromTeacherAnalytics }),
        //             ...(this.props.fromClassAnalytics && { fromClassAnalytics: this.props.fromClassAnalytics }),
        //             ...(this.props.reroutingData && { reroutingData: this.props.reroutingData }),
        //             ...(this.props.activeStudents && { activeStudents: this.props.activeStudents }),
        //             ...(this.props.totalStudents && { totalStudents: this.props.totalStudents }),
        //           }}>view</Link>) :
        //         row.statusBadge.props.children !== "Attended" ?
        //           <Link
        //             to="/"
        //             className="disabledCursor"
        //             onClick={(event) => event.preventDefault()} >
        //             View
        //           </Link>
        //           : ""
        //     )
        //   }
        // }
      ],
      contents: [...studentTestData],
    };
  };







  handleChartData = (content) => {
    const id = content.chapter_id;
    const chartData = content.students_progress[0] || [];
    return { id: id, contents: chartData };
  };

  handleScatterData = (content) => {
    console.log(content)
    const id = content.chapter_id;
    const scatterData = content.student_credits || [];
    return { id: id, contents: [...scatterData] };
  };

  getCourseProgressStudent = (chapterId) => {
    const { entity, ctx_user } = this.props;
    console.log(entity);
    let args = {
      chapterId: chapterId ? chapterId : "0",
      classId: entity?.class_id,
      academicYearId: ctx_user.user.acadYearId,
      curriculumId: entity.curriculum_id,
      coursePublishId: entity.course_publish_id,
      courseId: entity.course_id ? entity.course_id : entity.courseId || (entity && entity.course_publish_id),

    }
    console.log("RRRRR", args);
    if (ctx_user.user.dependantId) {
      args.dependantId = this.props.entity.child ? this.props.entity.child : ctx_user.user.dependantId;
    }
    this.setState({ loading: false });
    this.props.ctx_api
      .privateRequestRow({
        cmd: ctx_user.user.type === 4 ? "get_parent_course_progress_dependant" : "get_trainer_course_progress_student",
        args: args,
      })
      .then(this.handleGetCourseProgressStudentResponse)
      .catch(this.handleGetCourseProgressStudentFailure);
  };

  getModuleProgressStudent = (moduleId, type) => {
    const { entity, ctx_user } = this.props;
    let args = {
      videoUnitId: moduleId.toString(),
      type: type,
      classId: entity.class_id,
      academicYearId: ctx_user.user.acadYearId,
      curriculumId: entity.curriculum_id,
      coursePublishId: entity.course_publish_id,
      courseId: entity.course_id ? entity.course_id : entity.courseId,
    }
    if (ctx_user.user.dependantId) {
      args.dependantId = this.props.entity.childSelect ? this.props.entity.childSelect : ctx_user.user.dependantId;
    }
    this.setState({ loading: false });
    this.props.ctx_api
      .privateRequestRow({
        cmd: "get_trainer_module_progress_student",
        args: args,
      })
      .then(this.handleGetCourseProgressStudentResponse)
      .catch(this.handleGetCourseProgressStudentFailure);
  };
  handleGetCourseProgressStudentResponse = ({ rsp }) => {
    console.log('rsp : ', rsp)
    const tableData = this.state.tableData;
    const scatterData = this.state.scatterData;
    const chapterIds = this.state.chapterIds;
    const chartData = this.state.chartData;
    tableData[rsp.chapter_id] = this.handleTableData(rsp);

    console.log('table data : ', tableData);
    tableData[rsp.id] = rsp.type === "T" ? this.handleTableTestData(rsp) : rsp.type === "survey" ? this.handleTableSurveyData(rsp) : this.handleModuleTableData(rsp);
    scatterData[rsp.chapter_id] = this.handleScatterData(rsp);
    chartData[rsp.chapter_id] = this.props.ctx_user.user.type === 4 ? this.handleChartData(rsp) : "";
    chapterIds.push(rsp.chapter_id);
    this.setState({
      tableData: tableData,
      scatterData: scatterData,
      chartData: chartData,
      chapterIds,
      loading: true,
      type: rsp.type,
    });
  };

  handleGetCourseProgressStudentFailure = (err) => {
    console.log(err)
  }

  // search = async () => {
  //   const mkRequest = {
  //     cmd: "get_registration_details",
  //     args: {
  //       memberId: this.props.id,
  //       acadYearId: this.props.ctx_user.user.acadYearId,
  //     },
  //   };

  toggleSectionCollapse = (e, id) => {
    e.stopPropagation();
    const { chapterIds } = this.state;
    this.getCourseProgressStudent(id);
    // {
    //   this.props.ctx_user.user.type === 4 ?
    // !chapterIds.includes(id) && this.getCourseProgressStudent(id)
    //       :this.getCourseProgressStudent(id)
    // }
    if (this.props.onChange) {
      const curValue = this.props.value;
      const questionSections = curValue.map((s, i) => {
        return s.id === id ? { ...s, open: !s.open } : s;
      });
      this.setState({ selectedChapterId: id });
      this.props.onChange(questionSections);
    }
  };

  toggleDependantSectionCollapse = (e, id) => {
    e.stopPropagation();
    const { chapterIds } = this.state;
    !chapterIds.includes(id) && this.getCourseProgressStudent(id);
    if (this.props.onChange) {
      const curValue = this.props.value;
      const questionSections = curValue.map((s, i) => {
        return s.id === id ? { ...s, open: !s.open } : s;
      });
      this.setState({ selectedChapterId: id });
      this.props.onChange(questionSections);
    }
  };

  moduleSectionCollapse = (e, module_id, type) => {
    e.stopPropagation();
    const { moduleIds } = this.state;
    this.getModuleProgressStudent(module_id, type);

    if (this.props.onChange) {
      const curValue = this.props.value;
      const questionSections = curValue.map((s, i) => {
        return s.modules && s.modules.module_id !== null && s.modules.module_id === module_id ? { ...s, open: !s.open } : s;
      });
      this.setState({ selectedId: module_id });
      this.props.onChange(questionSections);
    }
  };


  handleStatisticsModalAction = (id) => {
    this.setState((s0) => ({
      selectedChapterId: id,
      statisticsModal: !s0.statisticsModal,
    }));
  };
  handleLeaderboardModalAction = (id) => {
    this.setState((s0) => ({
      selectedChapterId: id,
      leaderboardModal: !s0.leaderboardModal,
    }));
  };

  renderStudentTable = () => {
    const { selectedChapterId, selectedId, type } = this.state;
    const selectedChapter = this.props.value.find(ch => ch.id === selectedChapterId);
    // if (!selectedChapter) {
    // return null;
    // }

    return (
      this.state.type === "M" ?
        <ChapterStudentTable
          tableData={this.state.tableData[selectedId]} /* : this.state.tableData[selectedChapterId]}*/
          moduleId={selectedId}
          type={this.state.type}
          view="student"
          expandView={this.handleStatisticsModalAction}
          open={this.state.statisticsModal}
          loaded={this.state.loading}
          onRefresh={this.getModuleProgressStudent}
        /> :
        this.state.type === "T" ?
          <ChapterStudentTable
            tableData={this.state.tableData[selectedId]} /* : this.state.tableData[selectedChapterId]}*/
            testId={selectedId}
            type={this.state.type}
            addRedirection={this.props.addRedirection}
            view="student"
            expandView={this.handleStatisticsModalAction}
            open={this.state.statisticsModal}
            loaded={this.state.loading}
            onRefresh={this.getModuleProgressStudent}
            entity={this.props.entity}
          /> : this.state.type === "survey" ?
            <ChapterStudentTable
              tableData={this.state.tableData[selectedId]} /* : this.state.tableData[selectedChapterId]}*/
              testId={selectedId}
              type={this.state.type}
              addRedirection={this.props.addRedirection}
              view="student"
              expandView={this.handleStatisticsModalAction}
              open={this.state.statisticsModal}
              loaded={this.state.loading}
              onRefresh={this.getModuleProgressStudent}
              entity={this.props.entity}
            /> :
            <ChapterStudentTable
              tableData={this.state.tableData[selectedChapterId ? selectedChapterId : "0"]} /* : this.state.tableData[selectedChapterId]}*/
              chapterId={selectedChapterId}
              type={this.state.type}
              view="student"
              expandView={this.handleStatisticsModalAction}
              open={this.state.statisticsModal}
              loaded={this.state.loading}
              onRefresh={this.getCourseProgressStudent}
              coursepub_name={this.props.entity.coursepub_name || this.props.entity.course_publish_name || this.props.entity.course_name}
            />
    );
  };
  renderDependantChapterProgress = () => {
    return (
      this.props.value &&
      this.props.value.map((ch, i) => (
        <div className="chapter-section-itm" key={i}>
          <ChapterRibbon
            chapter={ch}
            expandChapter={(e) => this.toggleDependantSectionCollapse(e, ch.id)}
            open={ch.open}
          ></ChapterRibbon>
          <Collapse in={ch.open}>
            <div className="chapter-expanded">
              <Row>
                <Col lg={6}>
                  <ChapterStudentTable
                    tableData={this.state.tableData[ch.id]}
                    chapterId={ch.id}
                    view="student"
                    expandView={this.handleStatisticsModalAction}
                    open={this.state.statisticsModal}
                    loaded={this.state.loading}
                    onRefresh={this.getCourseProgressStudent}
                  />
                </Col>
                <Col lg={6}>
                  <ChapterScatterChart
                    data={this.state.scatterData[ch.id]}
                    chart={this.state.chartData[ch.id]}
                    chapterId={ch.id}
                    expandView={this.handleLeaderboardModalAction}
                    open={this.state.leaderboardModal}
                  />
                </Col>
              </Row>
            </div>
          </Collapse>
        </div>
      ))
    );
  };

  renderChapterProgress = () => {
    return (
      this.props.value &&
      this.props.value.map((ch, i) => (
        <ChapterList
          chapter={ch}
          chapterName={ch.chapter}
          chapterProgress={true}
          number={ch.id === "0" ? "" : i}
          expandChapter={(e) => this.toggleSectionCollapse(e, ch.id)}
          total={ch.module ? ch.module.length : ""}
          moduleDetails={ch.module ? ch.module.map((mod, i) => ({
            moduleid: mod.module_id,
            itemName: mod.module_name,
            type: mod.type,
            moduleCredits: mod.moduleCredit,
            isText: mod.is_text_only,
            isUrl: mod.is_url_only,
            is_html_only: mod.is_html_only,
            is_ppt: mod.is_ppt,
            is_audio: mod.is_audio,
            onSelectEntity: (e) => this.moduleSectionCollapse(e, mod.module_id, mod.type)
          })) : []}
        ></ChapterList>
      ))
    );
  };



  handleHideModal = () => {
    this.setState((s0) => ({
      statisticsModal: false,
      leaderboardModal: false,
    }));
  };

  renderLoadingProgress = () => (
    <Row>
      <Col md={12}>
        <Loader active width={30} padding="11em" />
      </Col>
    </Row>
  );
  render = () => {
    const {
      tableData,
      selectedChapterId,
      statisticsModal,
      leaderboardModal,
    } = this.state;
    return (
      <>
        {
          this.props.ctx_user.user.type === 4 ?
            <div>
              <Row>
                <Col md={12}>
                  {this.props.loading
                    ? this.renderDependantChapterProgress()
                    : this.renderLoadingProgress()}
                </Col>
              </Row>
            </div> :

            <div>
              <Row>
                <MediaQuery maxDeviceWidth={912}>
                  <Col lg={9}>
                    <div style={{ height: 'auto', overflowY: 'auto' }}>
                      {
                        // this.renderStudentTable() 
                        this.renderChapterProgress()
                      }
                    </div>
                  </Col>
                  <Col lg={3}>
                    {
                      // this.renderChapterProgress()
                      this.renderStudentTable()
                    }

                  </Col>
                </MediaQuery>
                <MediaQuery minDeviceWidth={914}>
                  <Col lg={9}>
                    {

                      this.renderStudentTable()
                    }
                  </Col>
                  <Col lg={3} >
                    <div style={{ height: '600px', overflowY: 'auto' }}>
                      {
                        this.renderChapterProgress()
                      }
                    </div>
                  </Col>
                </MediaQuery>
              </Row>
            </div>
        }
        <Modal
          dialogClassName={`item-chapter-progress-modal`}
          show={statisticsModal}
          onHide={this.handleHideModal}
        >
          <Modal.Body>
            <ChapterStudentTable
              tableData={tableData[selectedChapterId]}
              defaultPage={12}
              chapterId={selectedChapterId}
              view="student"
              expandView={this.handleStatisticsModalAction}
              open={statisticsModal}
            />
          </Modal.Body>
        </Modal>
        <Modal
          dialogClassName={`item-chapter-progress-modal`}
          show={leaderboardModal}
          onHide={this.handleHideModal}
        >
          <Modal.Body>
            <ChapterScatterChart
              data={this.state.scatterData[selectedChapterId]}
              chart={this.state.chartData[selectedChapterId]}
              chapterId={selectedChapterId}
              expandView={this.handleLeaderboardModalAction}
              open={this.state.leaderboardModal}
              size={950}
            />
          </Modal.Body>
        </Modal>
      </>
    );
  };
}

export default withApiContext(withUserContext(withLabelsContext(ChapterProgress)));
